import React from "react";
import "./approvedposterlist.css";

const AppPosterList = () => {
  return (
    <div className="poster-container">
      <div className="poster-content">
        <h1>Will be Uploaded Soon.....</h1>
        <p className="poster-content-p">
        For Further information, please contact at {" "}
          <a href="mailto:maryam.fatima@sihs.org.pk">
          maryam.fatima@sihs.org.pk
          </a>
        </p>
      </div>
    </div>
  );
};

export default AppPosterList;
